import { configureStore } from '@reduxjs/toolkit';
import platformDeviceReducer from './PlatformDeviceSlice';

const platformDeviceStore = configureStore({
  reducer: {
    device: platformDeviceReducer
  }
});

export default platformDeviceStore;